import * as React from "react";

import { Text } from "@seneca/senekit";

type Props = {
  message?: string;
  upgradeToGetAccessTo: string;
};

export default function SectionUpgradeMessage({
  message,
  upgradeToGetAccessTo
}: Props) {
  return (
    <Text align="center">
      {message
        ? message
        : "Upgrade your package to get access to " + upgradeToGetAccessTo}
    </Text>
  );
}
